import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { StorageSessionService } from '../../storage/services/storage.session.service';

@Injectable()
export class ChangePasswordGuard implements CanActivate {
	constructor(
		private storageSessionService: StorageSessionService,
		private router: Router,
		private authService: AuthService
	) {}

	canActivate(
		next: ActivatedRouteSnapshot,
		state: RouterStateSnapshot
	): Observable<boolean> | Promise<boolean> | boolean {
		return new Promise((resolve) => {
			const details = next.params;
			this.authService.verifyChangePasswordDetails(details).subscribe((response: any) => {
				if (response.success) {
					resolve(true);
				} else {
					this.router.navigate(['/login']);
					resolve(false);
				}
			});
		});
	}
}
